import {ListItemIcon, Menu, MenuItem} from "@material-ui/core";
import {Redo} from "@material-ui/icons";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import React, {useMemo} from "react";
import {makeStyles} from "@material-ui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles(() => ({
    contextPaper: {
        paddingTop: 0,
        paddingBottom: 0
    },
    menuItemRoot: {
        color: '#676767',
        '&:hover': {
            color: '#000000'
        }
    },
    listIconRoot: {
        minWidth: 30
    },
}));

const ContextMenu = (props) => {
    const classes = useStyles();
    const {contextMenu, onClose, removeItem, addItem} = props;

    const isOpen = useMemo(() => {
        return contextMenu.mouseY !== null && contextMenu.mouseX !== null
    }, [contextMenu.mouseY, contextMenu.mouseX])

    return (
        <Menu
            classes={{list: classes.contextPaper}}
            open={contextMenu.mouseY !== null}
            anchorReference={"anchorPosition"}
            anchorPosition={isOpen ? {top: contextMenu.mouseY, left: contextMenu.mouseX} : undefined}
            onClose={onClose}
        >
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addItem && addItem(contextMenu.index, 0);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Redo fontSize="small"/>
                </ListItemIcon>
                Insert Before
            </MenuItem>
            <MenuItem
                dense
                classes={{root: classes.menuItemRoot}}
                onClick={(e) => {
                    e.stopPropagation();
                    addItem && addItem(contextMenu.index, 1);
                    onClose();
                }}
            >
                <ListItemIcon classes={{root: classes.listIconRoot}}>
                    <Redo fontSize="small" style={{
                        transform: 'rotateX(-180deg) rotateY(10deg)',
                    }}/>
                </ListItemIcon>
                Insert After
            </MenuItem>
            {/*<MenuItem*/}
            {/*    dense*/}
            {/*    classes={{root: classes.menuItemRoot}}*/}
            {/*    onClick={(e) => {*/}
            {/*        e.stopPropagation();*/}
            {/*        duplicateItem && duplicateItem();*/}
            {/*        onClose();*/}
            {/*    }}*/}
            {/*>*/}
            {/*    <ListItemIcon classes={{root: classes.listIconRoot}}>*/}
            {/*        <FileCopyIcon fontSize="small"/>*/}
            {/*    </ListItemIcon>*/}
            {/*    Duplicate*/}
            {/*</MenuItem>*/}

            {removeItem && (
                <MenuItem
                    dense
                    classes={{root: classes.menuItemRoot}}
                    onClick={(e) => {
                        e.stopPropagation();
                        removeItem(contextMenu.index);
                        onClose();
                    }}
                >
                    <ListItemIcon classes={{root: classes.listIconRoot}}>
                        <HighlightOffIcon fontSize="small"/>
                    </ListItemIcon>
                    Delete
                </MenuItem>
            )}

        </Menu>
    )
}

export default ContextMenu;

ContextMenu.propTypes = {
    contextMenu: PropTypes.shape({
        mouseX: PropTypes.number || null,
        mouseY: PropTypes.number || null,
        index: PropTypes.number || null,
    }),
    onClose: PropTypes.func,
    removeItem: PropTypes.func,
    addItem: PropTypes.func,
}
